<template>
  <div class="centro-de-ayuda">
    <div v-if="showCDA">
      <div v-if="searchQuery">
        <help-center-breadcrumb :product-active="productActive" :menu-active="menuActive" :product-show="productShow" :menu-show="menuShow" @home="goHome" @product="goProduct"></help-center-breadcrumb>
        <div class="row pt-mobile-search">
          <div class="column products">
            <div class="title">
              Centro de Ayuda
            </div>
            <div class="description">
              ¡Encuentra aqu&iacute; lo que necesites!
            </div>
            <div class="container-search-result">
              <div class="container-search-bar">
                <img :src="iconSearching" @click="onEnterLocal" style="width: 24px; height: 24px;">
                <input class="search" type="text" v-model="textSearch" placeholder="Busca por palabra clave" @keyup.enter="onEnterLocal" @click="changeIcon"/>
                <button id="clear" @click="clear">X&nbsp;&nbsp;&nbsp;</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <div class="count" v-show="!flagSearch">
              Encontramos <b>{{resultSearch.length}}</b> resultados
              <div v-if="!resultSearch.length && !flagSearch" class="not-result">
                <img :src="icons.NO_RESULTS">
                <p>Busca por categoría o contactarte con un ejecutivo a través del chat</p>
              </div>
              <hr >
            </div>
            <div class="loader" v-show="flagSearch">Buscando coincidencias...</div>

            <div :key="question.id  + '-' + question.plan" v-for="question in resultSearch">
              <div class="search-question" @click="go(question.plan, question.topicId, question.id)">
                <div class="product-search">{{question.plan}}</div>
                <div>&nbsp;|</div>
                <div class="question-search">{{question.question}}</div>
              </div>
              <div class="search-response" v-html="question.response.substr(0, 89) + '...'"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!searchQuery">
        <help-center-breadcrumb :product-active="productActive" :menu-active="menuActive" :product-show="productShow" :menu-show="menuShow" @home="goHome" @product="goProduct" :show-home="!step3 || !mobile"></help-center-breadcrumb>
        <div v-if="mobile && step2 && (products.length !== 1)" class="product-tabs  pt-mobile">
          <ProductTab :key="item.order" v-for="item in products" :item="item" @click.native="selectProduct(item.code)"></ProductTab>
        </div>
        <div v-if="mobile && step2 && (products.length !== 1)" >
          <hr>
        </div>
        <div :class="[step1 ? 'pt-mobile-search row' : (step2) ? 'row' : 'pt-mobile row']">
          <!-- validate !menuShow -->
          <div class="column products" v-show="!menuShow">
            <div class="title" v-show="step1 || !mobile">
              Centro de Ayuda
            </div>
            <div class="description" v-show="step1">
              ¡Encuentra aqu&iacute; lo que necesites!
            </div>
            <div class="container-search" v-show="(step1 || (products.length === 1 && step2))">
              <div class="container-search-bar">
                <img :src="iconSearching" @click="onEnterLocal" style="width: 24px; height: 24px;">
                <input class="search" type="text" v-model="textSearch" placeholder="Busca por palabra clave" @keyup.enter="onEnterLocal" @click="changeIcon"/>
              </div>
            </div>
            <div v-show="step1" class="subtitle">
              <hr>
              Explora seg&uacute;n tu seguro
            </div>

            <div v-show="step2" class="subtitle">

              Explora tu {{productActive}}
              <br>
            </div>
            <div v-show="step2" class="subtitle-description">
              Selecciona la categoría de tu interés y resuelve tus dudas
            </div>
            <div class="list-product" v-show="step1">
              <product :key="item.order" v-for="item in products" :item="item" @click.native="selectProduct(item.code)"></product>
            </div>
            <div id="container-list">
              <div class="list-topic-menu" v-show="step2">
                <MenuTopic v-for="item in topics" :key="item.order" :item="item" @click.native="selectMenu(item.id)"></MenuTopic>
              </div>
            </div>
          </div>
          <div class="column topics" v-show="((!mobile && (step1 || step2 || step3)) || (mobile && menuShow))">
            <div class="description" v-show="step1">
              Selecciona el tema de tu inter&eacute;s
            </div>
            <div class="list-topic" v-show="step1">
              <topic :key="item.order" v-for="item in topics" :item="item" @click.native="showTopic(item.id)"></topic>
            </div>
            <questions v-if="step3" :key="questionKey" :questions="questions" :active="questionActive" @select="trackQuestion" @link="trackLink"></questions>
          </div>
          <div class="column more-help-section"></div>
        </div>
      </div>
    </div>
    <div v-else>
      <help-center-loader></help-center-loader>
    </div>
  </div>

</template>

<script>
/**
 * @component HelpCenter
 * @description Centro de Ayuda: productos del usuario con sus temas y preguntas, y buscador por palabra clave.
 * El estado se reparte en mixins (navegación, catálogo, búsqueda y tracking) y las llamadas HTTP salen de
 * help-center.service (endpoints /v1/help-center/* de portal-api-zonasegura por Apigee). Los estilos están en
 * assets/css/help-center/help-center.css.
 * @example <help-center :list-products="['PlanGarantizado']" :data="{ nombres: 'Ana' }" />
 */
import HelpCenterBreadcrumb from './HelpCenterBreadcrumb.vue'
import HelpCenterLoader from './HelpCenterLoader.vue'
import Product from './Product.vue'
import ProductTab from './ProductTab.vue'
import Topic from './Topic.vue'
import MenuTopic from './MenuTopic.vue'
import Questions from './Questions.vue'
import helpCenterNavigation from '@/mixins/help-center-navigation.mixin'
import helpCenterCatalog from '@/mixins/help-center-catalog.mixin'
import helpCenterSearch from '@/mixins/help-center-search.mixin'
import helpCenterTracking from '@/mixins/help-center-tracking.mixin'
import { ICONS } from '@/constants/help-center'

export default {
  name: 'HelpCenter',
  components: {
    HelpCenterBreadcrumb,
    HelpCenterLoader,
    Product,
    ProductTab,
    Topic,
    MenuTopic,
    Questions
  },
  mixins: [helpCenterNavigation, helpCenterCatalog, helpCenterSearch, helpCenterTracking],
  props: {
    listProducts: {
      type: Array
    },
    search: {
      type: String
    },
    data: {
      type: Object
    }
  },
  data () {
    return {
      icons: ICONS
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
::-webkit-scrollbar {
  width: 3px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px transparent;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb {
  background: #C4C4C4;
  border-radius: 3px;
}
</style>
<style>
@import url("../../assets/css/help-center/help-center.css");
</style>



// WEBPACK FOOTER //
// src/components/help-center/HelpCenter.vue